import {observable, computed, action} from 'mobx';
import {getIn} from '../utils';
import createSelector, {LruCacheObject} from 're-reselect';

class BestOffer {
  constructor(content) {
    this.content = content;
  }

  get bestSelectableOffer() {
    if(this.content.RentalTransactionOfferSelectable && this.content.RentalTransactionOfferSelectable.length>0) {
      return this.content.RentalTransactionOfferSelectable[0];
    }
  }

  get snippetForTransaction() {
    return {RentalObjectOffer: this.content};
  }
}

class BestAccessoryOffer {
  constructor(content) {
    this.content = content;
  }

  @computed get selectables() {
    return getIn(this.content, ['RentalTransactionAccessoriesOfferSelectable'], []);
  }
}

class RuleException {
  @observable content = {};

  constructor(content) {
    this.content = content;
  }

  @computed get message() {
    return this.content.Message;
  }

  @computed get severity() {
    return this.content.Severity;
  }
}
 
export class BestOffers {
  @observable content = {};
  
  @computed get bestOfferItems() {
    return getIn(this.content, ['RentalObjectOffer'], []).map(o => {
      return new BestOffer(o);
    })
  }

  @computed get transactionUpdater() {
    return {
      RentalObjectOffer: this.bestOfferItems.map(o => o.content),
    };
  }

  /*@computed get firstOffer() {
    return this.bestOfferItems[0];
  }*/

  @computed get ruleExceptions() {
    return getIn(this.content, ['RuleExceptionData'], []).map(o => {
      return new RuleException(o);
    })
  }  

  @computed get accessories() {
    return getIn(this.content, ['RentalAccessoriesObjectOffer'], []).map(o => {
      return new BestAccessoryOffer(o);
    });
  }

  @computed get accessoryOffers() {
    return getIn(this.content, ['RentalAccessoriesObjectOffer'], []).map(o => {
      return new BestAccessoryOffer(o);
    });
  }

  constructor(api) {
    this.api = api;
  }

  @action async fetch({startDate, endDate, organizationId, objectId, timeUnit, oldStartDate, oldEndDate}) {
    if(!objectId) {
      throw new Error('ObjId is not given.')
    }
    this.content = await this.api.getBestRentalTransactionOffers({
      startDate, 
      endDate, 
      organizationId, 
      objectId, 
      granularityTimeUnitId: timeUnit, 
      oldStartDate, 
      oldEndDate,
    })    
  }

  cFetch = createSelector(
    [p => p],
    (p) => this.fetch(p)
  )(
    ({startDate, endDate, organizationId, objectId, timeUnit, oldStartDate, oldEndDate}) => 
      `${startDate}@${endDate}@${organizationId}@${objectId}@${timeUnit}@${oldStartDate}@${oldEndDate}`,
    {cacheObject: new LruCacheObject({cacheSize: 1}), }
  );   
/*
  @action async load() {
    if(this._loadingPromise) {
      return this._loadingPromise;
    }
    try {
      this._loadingPromise = this.api.getBestRentalTransactionOffers({
        startDate: this.scene.state.startDate, 
        endDate: this.scene.state.endDate, 
        organizationId: this.scene.state.organizationId, 
        objectId: this.scene.state.objectId, 
        granularityTimeUnitId: this.scene.state.timeUnit, 
        oldStartDate: undefined, 
        oldEndDate: undefined,
      });
      this.content = await this._loadingPromise;
    }
    finally {
      this._loadingPromise = undefined;
    }

  }  */
}


// WEBPACK FOOTER //
// ./src/model/BestOffers.js